/* eslint-disable max-lines-per-function */
import { brand } from '@websrc/App/Helpers/brand'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { Link } from 'gatsby'
import React, { FC, forwardRef, Ref } from 'react'

import { DarkCoralLogo } from './variants/DarkCoralLogo'
import { LightCoralLogo } from './variants/LightCoralLogo'

export interface CoralLogoProps {
  className?: string
  ref?: Ref<SVGSVGElement>
  isDarkBackground?: boolean
}
export const CoralLogo: FC<CoralLogoProps> = forwardRef((props, ref: Ref<SVGSVGElement>) => {
  const locale = useLocale()
  const { className, isDarkBackground } = props

  return (
    <Link
      aria-label={brand.name}
      className={className}
      style={{ width: '148px', minWidth: '148px', display: 'flex' }}
      to={`/${locale}`}
    >
      {isDarkBackground ? <LightCoralLogo ref={ref} /> : <DarkCoralLogo ref={ref} />}
    </Link>
  )
})
